import React, { useMemo } from 'react'
import { MultiSelectFilter } from '@/components/Filter/MultiSelectFilter'
import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

export const TrackingMetricsFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const trackingMetrics = useAppSelector((state) => state.tradingAccounts.rewardTrackingMetrics)
  const data = useMemo(
    () => trackingMetrics.map((x) => ({ id: x.id, label: x.name, value: x.id })),
    [trackingMetrics]
  )

  return (
    <MultiSelectFilter
      placeholder='Tracking Metrics'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
